import cleanedFilename from '~/util/cleanedFilename';

export default {
  ISSUES: `${cleanedFilename(__filename)}-issues`,
};
